import React from "react";
import { BaseCard, SVGIcon } from "../baseCard/baseCard.tsx";
import {
    getFontSizes,
    getTitleHeight,
    darkenColor,
} from "../baseCard/BaseCardUtils.ts";
import "./HealthCard.css";

interface HealthCardProps {
    category: string;
    title: string;
    subtitle1: string;
    score1: number; // 1-5
    subtitle2: string;
    score2: number; // 1-5
    highlight?: boolean;
}

const HealthCard: React.FC<HealthCardProps> = ({
    category,
    title,
    subtitle1,
    score1,
    subtitle2,
    score2,
    highlight = false,
}) => {
    const fontSizes = getFontSizes(highlight);
    const titleHeight = getTitleHeight(highlight);
    const color = "var(--color-light-gray)";
    const shapeColor = darkenColor(color);

    const renderDots = (score: number) => {
        const dots = [];
        for (let i = 0; i < 10; i++) {
            dots.push(
                <div key={i} className="healthCard-icon-container">
                    {(i < score / 10) ?
                        <SVGIcon
                            className="dotCard-icon"
                            viewBox="0 0 24 24"
                            fillColor={"#22ad7a"}
                            path={svgPaths.hearthIcon}
                        />

                        :
                        <SVGIcon
                            className="dotCard-icon"
                            viewBox="0 0 24 24"
                            fillColor={"#BABABA"}
                            path={svgPaths.emptyHearth}
                        />
                    } </div>

            );
        }
        return dots;
    };

    const svgPaths = {
        topShape:
            "M20.7637 1.11044e-05C9.71799 1.24175e-05 0.76368 8.95433 0.763673 20L0.763678 97.4131C9.37694 104.498 32.5399 112.037 67.7002 90.1162C103.94 67.5225 112.736 17.7127 114.172 0L20.7637 1.11044e-05Z",
        bottomShape:
            "M206.493 109.598C206.493 120.643 197.539 129.598 186.493 129.598H0.626953C8.79625 105.382 42.9206 56.9502 114.063 56.9502C185.206 56.9502 205.326 19.2817 206.493 0.447266V109.598Z",
        hearthIcon:
            "M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z",
        emptyHearth:
            "M12 21.593c-5.63-5.539-11-10.297-11-14.402 0-3.791 3.068-5.191 5.281-5.191 1.312 0 4.151.501 5.719 4.457 1.59-3.968 4.464-4.447 5.726-4.447 2.54 0 5.274 1.621 5.274 5.181 0 4.069-5.136 8.625-11 14.402m5.726-20.583c-2.203 0-4.446 1.042-5.726 3.238-1.285-2.206-3.522-3.248-5.719-3.248-3.183 0-6.281 2.187-6.281 6.191 0 4.661 5.571 9.429 12 15.809 6.43-6.38 12-11.148 12-15.809 0-4.011-3.095-6.181-6.274-6.181"
    }


    return (
        <BaseCard highlight={highlight} color={color} className="dotCard-card">
            <SVGIcon
                className="baseCard-icon-top-right"
                viewBox="0 0 115 105"
                fillColor={shapeColor}
                path={svgPaths.topShape}
            />

            <SVGIcon
                className="baseCard-icon-bottom-left"
                viewBox="0 0 207 130"
                fillColor={shapeColor}
                path={svgPaths.bottomShape}
            />

            <div className="baseCard-content dotCard-content">
                <div className="dotCard-header">
                    <div
                        className="dotCard-category"
                        style={{ fontSize: fontSizes.category }}
                    >
                        {category.toUpperCase()}
                    </div>

                    <div
                        className="dotCard-title"
                        style={{
                            fontSize: fontSizes.title,
                            height: titleHeight,
                        }}
                    >
                        {title}
                    </div>

                    <div
                        className="baseCard-divider dotCard-divider"
                        style={{
                            width: "calc(100% + 2 * var(--spacing-3))",
                        }}
                    ></div>
                </div>

                <div className="dotCard-main-content">
                    <div className="dotCard-score-section">
                        <div className="dotCard-score-header">
                            <span
                                className="dotCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {subtitle1}
                            </span>
                            <span
                                className="dotCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {score1}{"%"}
                            </span>
                        </div>

                        <div className="healthCard-dots-container">{renderDots(score1)}</div>
                        <div className="dotCard-thin-divider"></div>
                    </div>
                    <div className="dotCard-score-section">
                        <div className="dotCard-score-header">
                            <span
                                className="dotCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {subtitle2}
                            </span>
                            <span
                                className="dotCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {score2}{"%"}
                            </span>
                        </div>

                        <div className="healthCard-dots-container">{renderDots(score2)}</div>

                    </div>
                </div>
            </div>
        </BaseCard>
    );
};

export default HealthCard
